module.exports = __webpack_public_path__ + "static/media/radio-on-check.1720e6dd.svg";